import PropTypes from 'prop-types';
import defaults from 'lodash/defaults';
import isNull from 'lodash/isNull';
import omitBy from 'lodash/omitBy';
import { Box, useTheme } from '@mui/material';
import {
  EmbedElement, TypographyElement, useContentElement, useContentVisibility, VisibilityScheme,
} from '@plugins/next-cms-core';
import Container from '../atoms/Container';

export default function EmbedBlock(props) {
  const { data } = props;
  const theme = useTheme();
  const { elementData } = useContentElement(
    data,
    EmbedBlock.dataSchema,
  );

  const {
    embed,
    visibility,
  } = elementData;
  const title = omitBy(elementData.title, isNull);
  defaults(title, {
    semanticVariant: 'h3',
    displayVariant: 'h3',
  });

  const rootStyles = useContentVisibility(visibility, {
    paddingTop: {
      xs: theme.spacing(5),
      md: theme.spacing(10),
    },
    paddingBottom: {
      xs: theme.spacing(5),
      md: theme.spacing(10),
    },
  });

  return (
    <>
      <Box sx={rootStyles}>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          {title && (
            <Box sx={{ marginBottom: 5 }}>
              <TypographyElement
                align="center"
                data={title}
              />
            </Box>
          )}
          <Container
            sx={{
              width: embed.provider === 'youtube' ? '100%' : 'auto',
              maxWidth: '800px !important',
            }}
          >
            <EmbedElement
              data={embed}
              options={{
                // https://developers.google.com/youtube/player_parameters
                modestbranding: 1,
                rel: 0,
              }}
            />
          </Container>
        </Box>
      </Box>
      <style global jsx>
        {`
          .player,
          .player-shorts {
            flex: 1;
            display: block;
            width: 100%;
            height: 100%;
          }

          .player {
            aspect-ratio: 16 / 9;
          }

          .player-shorts {
            aspect-ratio: 9 / 16;
            max-width: 315px;
          }
        `}
      </style>
    </>
  );
}

EmbedBlock.typeName = 'ComponentContentEmbed'; // Strapi element type
EmbedBlock.propTypes = {
  data: PropTypes.shape({
    title: TypographyElement.propTypes,
    embed: EmbedElement.propTypes,
    visibility: VisibilityScheme.propTypes,
  }).isRequired,
};

EmbedBlock.graphQlSchema = `
... on ${EmbedBlock.typeName} {
  id
  title {
    ${TypographyElement.graphQlSchema}
  }
  embed {
    ${EmbedElement.graphQlSchema}
  }
  visibility {
    ${VisibilityScheme.graphQlSchema}
  }
}
`;
